<img [alt]="alt" [routerLink]="linkInterno" [linkExterno]="linkExterno" [src]="src">
